module.exports = __webpack_public_path__ + "img/logo_personajes_lg.992b0579.svg";